export default "/static/images/build_base_4.png?5c01238a2bd9f9d1cda69a0d004ce63a";